<template>
  <div>
    <v-app-bar
      app
      color="#5C9DF2"
      dark
      height="65"
      flat
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-row align="center" no-gutters>
        <v-col cols="auto">
          <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer" />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-avatar color="white" size="36">
            <img src="@/assets/images/blu_single_blue_sq.png" alt="Blu Capital">
          </v-avatar>
        </v-col>
      </v-row>
    </v-app-bar>

    <!-- Drawer principal -->
    <v-navigation-drawer
      app
      v-model="drawer"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="$vuetify.breakpoint.smAndDown"
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      :mini-variant.sync="mini"
      width="280"
      mini-variant-width="72"
    >
      <!-- Header del usuario -->
      <v-list dense nav v-if="$store?.getters?.user?.client">
        <v-list-item>
          <v-list-item-avatar size="64" tile>
            <img src="@/assets/images/Blu.png" alt="Blu Capital" />
          </v-list-item-avatar>
          <v-list-item-content  v-if="!mini">
            <v-list-item-title class="font-weight-bold primary--text">
              {{ $store?.getters.user?.firstName?.toUpperCase() }}
            </v-list-item-title>
            <v-list-item-subtitle class="grey--text text--darken-1">
              {{ $store?.getters.user?.client?.entityName?.toUpperCase() }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider v-if="!mini" />

      <!-- GENERAL -->
      <v-list dense nav>
        <v-subheader
          v-if="!mini"
          class="font-weight-bold text-uppercase grey--text text--darken-1"
        >
          General
        </v-subheader>

        <!-- @PILOT - start -->
        <!-- Si el cliente no pertenece al grupo piloto -->
        <v-list-item
        v-if="!activePortafolio.length"
          link
          @click="goTo('factoringDetail')"
          :class="{ 'active-item': $route.path === '/'}"
        >
          <v-list-item-icon>
            <v-icon :color="$route.path === '/' ? 'primary' : 'grey'">
              mdi-view-dashboard-outline
            </v-icon>
          </v-list-item-icon>

          <v-list-item-title v-if="!mini">Dashboard</v-list-item-title>
        </v-list-item>
        <!-- @PILOT - end -->

        <!-- Si el cliente sí pertenece al grupo piloto -->
        <div v-else>
          <v-list-item
            link
            @click="togglePortafolio"
            class="portfolio-parent"
            :class="{
                    'active-item':
                      $route.path === '/' || $route.path.startsWith('/detail/')
                  }"
          >
            <v-list-item-icon>
              <v-icon :color="portafolioOpen ? 'primary' : 'grey'">
                mdi-view-dashboard-outline
              </v-icon>
            </v-list-item-icon>

            <v-list-item-title v-if="!mini">Productos</v-list-item-title>

            <v-spacer />

            <v-icon v-if="!mini" small color="grey">
              {{ portafolioOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </v-list-item>

          <!-- SUBMENÚ -->
          <v-expand-transition>
            <div v-show="portafolioOpen" class="portfolio-submenu">
              <div class="vertical-line"></div>

              <div class="submenu-content">
                <v-list-item
                  link
                  class="subitem"
                  :class="{
                    'active-subitem':
                      $route.path === '/'
                  }"
                  @click="goTo('portafolio')"
                >
                  <v-list-item-title v-if="!mini">
                    Todos
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-for="item in activePortafolio"
                  :key="item.id"
                  link
                  class="subitem"
                  :class="{
                    'active-subitem':
                      $route.query?.folio === item.folio || ($route.path.includes('factoring') && ['BI', 'FB'].includes(item.product?.code))
                  }"
                  @click="goToDetail(item.folio)"
                >
                  <v-list-item-title v-if="!mini">
                    {{ item.product?.code }} - {{ item.folio }}
                  </v-list-item-title>
                </v-list-item>
              </div>
            </div>
          </v-expand-transition>
        </div>
      </v-list>

      <v-divider v-if="!mini" class="my-2" />

      <!-- REPORTES-->
      <v-list dense nav>
        <v-subheader
          v-if="!mini && reportItems.length"
          class="font-weight-bold text-uppercase grey--text text--darken-1"
        >
          Reportes
        </v-subheader>

        <v-list-item
          v-for="item in reportItems"
          :key="item.title"
          link
          @click="goTo(item.link)"
          :class="{ 'active-item': item.path === $route.path }"
        >
          <v-list-item-icon>
            <v-icon :color="item.path === $route.path ? 'primary' : 'grey'">
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>

          <v-list-item-title v-if="!mini">{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider v-if="!mini" class="my-2" />

      <!--  CUENTA -->
      <v-list dense nav>

        <v-subheader v-if="!mini" class="font-weight-bold text-uppercase grey--text text--darken-1">
          Cuenta
        </v-subheader>

        <v-list-item
          v-for="item in filteredAccountItems"
          :key="item.title"
          link
          @click="goTo(item.link)"
          :class="{ 'active-item': item.path === $route.path }"
        >
          <v-list-item-icon class="relative-position">
            <div class="badge-wrapper">
              <v-icon :color="item.path === $route.path ? 'primary' : 'grey'">
                {{ item.icon }}
              </v-icon>

              <span v-if="item.icon === 'mdi-email-outline' && unreadCount > 0" class="badge">
                {{ unreadCount }}
              </span>
            </div>
          </v-list-item-icon>

          <v-list-item-title v-if="!mini">{{ item.title }}</v-list-item-title>
        </v-list-item>

      </v-list>

      <v-spacer />
      <v-divider v-if="!mini" class="my-2" />

      <!-- Logout -->
      <v-list dense nav>
        <v-list-item link @click="goTo('logout')" class="logout-item">
          <v-list-item-icon>
            <v-icon color="error">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title v-if="!mini" class="error--text">Cerrar Sesión</v-list-item-title>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
  </div>
</template>

<script>
import productMixin from '../mixins/productMixin'
import NotificationService from '../services/NotificationService'

export default {
  name: 'TheSideBar',
  mixins: [productMixin],

  data () {
    return {
      drawer: false,
      mini: true,
      portafolioOpen: false,
      portafolio: [],
      oldReportItems: [
        { title: 'Referencias de Pago', icon: 'mdi-currency-usd', link: 'paymentReferences', path: '/paymentReferences' },
        { title: 'Facturas Liquidadas', icon: 'mdi-cash-multiple', link: 'invoices', path: '/invoices' },
        { title: 'Historial de Facturación', icon: 'mdi-file-xml-box', link: 'invoicesHistory', path: '/invoicesHistory' },
        { title: 'Detalle de Intereses', icon: 'mdi-folder-download-outline', link: 'interestHistory', path: '/interestHistory' }
      ],
      accountItems: [
        { title: 'Mi Perfil', icon: 'mdi-account-outline', link: 'profile', path: '/profile' }
      ],
      unreadCount: 0
    }
  },
  watch: {
    mini (isMini) {
      if (isMini) this.portafolioOpen = false
      else this.portafolioOpen = true
    }
  },
  async beforeMount () {
    const isLoggedIn = this.$store?.getters?.isLoggedIn

    if (!isLoggedIn) {
      window.location.replace('/login')
    }
  },
  mounted () {
    this.checkMini()
    this.loadPortafolio()
    this.setIndicators()

    // ---- Funcionalidad de Notificationes pendiente de activar - PR  26/11/2025
    // this.loadUnreadNotifications()
    // this.refreshInterval = setInterval(() => {
    //   this.loadUnreadNotifications()
    // }, 60000)
  },
  methods: {
    togglePortafolio () {
      this.portafolioOpen = !this.portafolioOpen
    },
    async loadPortafolio () {
      const loader = this.$loading.show()
      try {
        const clientId = this.$store?.getters?.user?.clientId
        await this.setClientPortafolio(clientId)

        // Si no tiene portafolio (puede ser por no formar parte del piloto) redirige al dashboard de factoraje por default
        if (this.$route.name === 'portafolio' && this.activePortafolio.length === 0) this.goTo('factoringDetail')
        // Si solo tiene un crédito activo, ir directamente al detalle de ese
        if (this.$route.name === 'portafolio' && this.activePortafolio.length === 1) this.goToDetail(this.activePortafolio[0].folio)
      } catch (err) {
        console.error(err)
        this.$swal({
          icon: 'error',
          title: 'Ocurrió un error',
          text: 'Hubo un problema al cargar tu portafolio. Por favor inténtalo nuevamente.',
          confirmButtonText: 'Cerrar',
          confirmButtonColor: '#d93025'
        })
      } finally {
        loader.hide()
      }
    },
    checkMini () {
      this.mini = this.$vuetify.breakpoint.mdAndUp
    },
    goTo (routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName })
      }
    },
    async loadUnreadNotifications () {
      const { count } = await NotificationService.list({ clientUserId: this.$store?.getters.user.userId, isActive: true, type: 'inbox', seen: false })
      this.unreadCount = count
    }
  },
  computed: {
    filteredAccountItems () {
      return this.accountItems.filter(item => !item.adminOnly || this.$store?.getters.user.isAdmin)
    },
    reportItems () {
      // Si NO es piloto, se le muestran los reportes de siempre
      if (!this.activePortafolio?.length) return this.oldReportItems

      const items = []

      if (this.hasFactoring) {
        items.push(
          { title: 'Referencias de Pago', icon: 'mdi-currency-usd', link: 'paymentReferences', path: '/paymentReferences', applicableProducts: this.factoringCodes },
          { title: 'Facturas Liquidadas', icon: 'mdi-cash-multiple', link: 'invoices', path: '/invoices' },
          { title: 'Detalle de Intereses', icon: 'mdi-folder-download-outline', link: 'interestHistory', path: '/interestHistory', applicableProducts: this.factoringCodes }
        )
      }

      if (this.accessiblePortfolio?.length) {
        items.push({ title: 'Documentos Fiscales', icon: 'mdi-file-certificate-outline', link: 'invoicesReport', path: '/reports/invoices', applicableProducts: this.amortizedCodes })
      }

      return items
    }
  }
}
</script>

<style scoped>
.active-item {
  background-color: rgba(92, 157, 242, 0.12);
  border-left: 4px solid #5C9DF2;
  transition: 0.2s ease;
}
.logout-item:hover {
  background-color: rgba(244, 67, 54, 0.1);
}
.v-list-item {
  border-radius: 8px;
  margin: 2px 8px;
}
.v-subheader {
  font-size: 0.75rem;
  letter-spacing: 1px;
}
.relative-position {
  position: relative;
}

.badge-wrapper {
  position: relative;
  display: inline-block;
}

.badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #E53935; /* rojo */
  color: white;
  font-size: 0.7rem;
  font-weight: bold;
  border-radius: 50%;
  padding: 2px 5px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.portfolio-parent {
  padding-left: 12px !important;
}

.portfolio-submenu {
  display: flex;
  position: relative;
  margin-left: 28px;
}

.vertical-line {
  width: 1px;
  background-color: #cfcfcf;
  margin-right: 12px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.submenu-content {
  flex-grow: 1;
}

.subitem {
  padding-left: 1 !important;
  min-height: 28px;
}

.subitem:hover {
  background-color: #f5f5f5 !important;
}

.active-item {
  background-color: #bbdef05d !important;
  border-left: 3px solid #46659B;
}

.active-subitem {
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: #46659B;
  text-decoration-thickness: 2px;
  font-weight: 500;
}

</style>
